import React from 'react';
import { useDispatch } from 'react-redux';
import { externalFile } from 'hellospa/page/prep-and-send/data/actions/file';
import {
  BoxIntegration, UploadIntegrationType, ExternalFileContents,
} from 'hellospa/page/prep-and-send/data/types/integration';
import CustomPicker from './custom-picker';
import ReAuthModal from './reauth-modal';
import boxIcon from 'images/external_logo_med_B.png';

type Props = {
  settings: BoxIntegration,
  shouldTriggerPicker: boolean,
  toggleIntegrationPicker: (integration: string, status: boolean) => void,
}

export default function BoxFilePicker({
  settings,
  shouldTriggerPicker,
  toggleIntegrationPicker,
}: Props) {
  const dispatch = useDispatch();

  const onClose = React.useCallback(() => {
    toggleIntegrationPicker(UploadIntegrationType.Box, false);
  }, [toggleIntegrationPicker]);

  const onFileSelect = React.useCallback((file: ExternalFileContents) => () => {
    dispatch(externalFile(UploadIntegrationType.Box, file.id, file.name));
    // toggle the modal
    onClose();
  }, [dispatch, onClose]);

  // if clicked on the integration icon but it's not enabled,
  // trigger the modal to initiate auth
  if (shouldTriggerPicker && !settings.enabled) {
    return (
      <ReAuthModal
        integration={UploadIntegrationType.Box}
        integrationIcon={boxIcon}
        isOpen={shouldTriggerPicker && !settings.enabled}
        onClose={onClose} />
    );
  }

  // return null if it hasn't been triggered or enabled
  if (!shouldTriggerPicker || !settings.enabled) {
    return null;
  }

  return (
    <CustomPicker
      integration={UploadIntegrationType.Box}
      isOpen={shouldTriggerPicker && settings.enabled}
      integrationIcon={boxIcon}
      onFileSelect={onFileSelect}
      onClose={onClose} />
  );
}
